export const TYPE_CARD = 'KANBAN_CARD';
